import React, { Component } from 'react';
import _ from "lodash";

export default class ProjectCommission extends Component {
	render() {
		const {project} = this.props.projects
		return (
			<div className="columns is-centered">
				<div className="column">
					<h1 className="title is-1">Comisiones</h1>

					<table className="inm-table">
						<tbody>
						{!_.isEmpty(project.comissions_review) && !_.isEmpty(project.comissions_review.survey_version_phase) && !_.isEmpty(project.comissions_review.survey_version_phase.survey) ?
							_.map(project.comissions_review.survey_version_phase.survey.children_questions,(row,key)=>{
								//console.log('row: ',row);
								if(row.type === 'group'){
									return [
										<tr key={`group-${key}`}>
											<td colSpan={2} className="has-text-left">
												<strong>{`${key+1}. ${row.name}`}</strong>
											</td>
										</tr>,
										_.map(row.children_questions,(item,k) => {
											return <RowQuestion key={k} row={row} {...this.props}/>
										})
									]
								}else {
									return <RowQuestion key={key} number={key+1} row={row} {...this.props}/>
								}
							}):<tr><td colSpan={2}><p className="has-text-primary"><span className="icon has-text-danger"><i className="fa fa-lg fa-exclamation-triangle" /></span> Sin información <br /><br /></p></td></tr>}
						<tr>
							<td className="has-text-left" style={{ backgroundColor: '#a864a9'}} colSpan={2}>
								<strong style={{color: '#fff'}}>Comentarios generales</strong>
							</td>
						</tr>
						<tr>
							<td className="has-text-left" colSpan={2}>
								{!_.isEmpty(project.comissions_review) ?
								<span dangerouslySetInnerHTML={{__html:project.comissions_review.comments && project.comissions_review.comments !== '<p><br></p>' ? project.comissions_review.comments : 'Ninguno'}}></span>:''}
							</td>
						</tr>
						<tr>
							<td className="has-text-right" style={{ backgroundColor: '#a864a9'}}>
								<strong style={{color: '#fff'}}>Puntuación total:</strong>
							</td>
							<td >
								<strong>{this._totalScore()}</strong>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		)
	}

	_totalScore(){
		let { project } = this.props.projects;
		let total_score=project && project.answers ? _.sum(_.map(project.answers,(row)=>{
			if(row){
				return row.answer_number;
			}else {
				return 0;
			}
		})):0;

		return total_score;
	}
}

class RowQuestion extends Component {
	render(){
		let { row} = this.props
		//let findValue = _.find(projects.commission.answers, {question_id: row.id});
		return(
			<tr>
				<td>
					{this.props.number ?
						<div className="field">
							<strong>{(this.props.number)+'. '+row.name}</strong>
						</div>:<p>{row.name}</p>}
				</td>
				<td>
					<p>{row.answer.answer_text}</p>
				</td>
			</tr>
		)
	}
}



// WEBPACK FOOTER //
// ./src/elements/projects/commissions.jsx